import { Box, Text, Icon } from "@chakra-ui/react";
import { AppContext } from "AppProvider/AppContext";
import { useContext } from "react";
import { BsFolderCheck } from "react-icons/bs";

const DashWidget = ({ title, count, link, props }: any) => {
  const { workFlowData } = useContext(AppContext);

  return (
    <Box
      mt="0.2rem"
      boxShadow="0 2px 10px rgba(0, 0, 0, 0.12)"
      p="1rem 1.2rem"
      rounded="2xl"
      textAlign="center"
      minH="100px"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      cursor="pointer"
      // bg="rgba(255,255,255,0.08)"
      backdropFilter="blur(4px)"
      transition="all 0.25s ease"
      _hover={{ transform: "translateY(-3px)", boxShadow: "0 6px 16px rgba(0,0,0,0.18)" }}
      onClick={() => link && link()}
      {...props}
    >
      <Text
        fontSize="sm"
        fontWeight="600"
        color="whiteAlpha.900"
        textTransform="uppercase"
        letterSpacing="0.5px"
        mb="0.2rem"
        noOfLines={1}
        opacity={0.9}
      >
        {title} {workFlowData?.documentType && (typeof workFlowData.documentType === 'object' ? workFlowData?.documentType?.label || workFlowData?.documentType?.value : workFlowData?.documentType)}
      </Text>

      {count || count === 0 ? (
        <Text
          fontSize="3xl"
          fontWeight="800"
          color="white"
          lineHeight="1.1"
        >
          {count}
        </Text>
      ) : (
        <Icon
          as={BsFolderCheck}
          w={7}
          h={7}
          color="whiteAlpha.900"
          opacity={0.95}
        />
      )}
    </Box>
  );
};

export default DashWidget;
